export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.15.4';
//# sourceMappingURL=version.js.map


// WEBPACK FOOTER //
// ../node_modules/@sentry/browser/esm/version.js